import { queryAvailability } from './api/query-availability';
import { getLocalDateTimeEndOfDay, getLocalDateTimeStartOfDay } from './date-utils';
const deduplicateSlots = (slots)=>{
    if (!slots) {
        return undefined;
    }
    const seen = new Set();
    return slots.filter((entry)=>{
        const key = `${entry.slot?.startDate}_${entry.slot?.endDate}`;
        if (seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    });
};
export const getAvailabilitySlots = ({ httpClient: _httpClient, errorHandler })=>{
    return async ({ serviceId, selectedDate, timeZone })=>{
        const fromLocalDate = getLocalDateTimeStartOfDay(selectedDate);
        const toLocalDate = getLocalDateTimeEndOfDay(selectedDate);
        const availabilityEntries = (await queryAvailability({
            httpClient: _httpClient,
            errorHandler,
            request: {
                query: {
                    filter: {
                        serviceId: [
                            serviceId
                        ],
                        startDate: fromLocalDate,
                        endDate: toLocalDate,
                        bookable: true
                    }
                },
                timezone: timeZone,
                allowProxyToAvailability: true
            }
        }))?.availabilityEntries;
        return deduplicateSlots(availabilityEntries);
    };
};

//# sourceMappingURL=get-availability-slots.js.map